import styled from 'styled-components';
import { buttonStyles } from '../../styled/buttons';
import Button from '../../button';
import { breakpoint } from '../../theme/breakpoint';

export const EditWrapper = styled.div`
  position: fixed;
  display: flex;
  justify-content: space-between;
  right: 0;
  ${({ $showQuickExitButton }) =>
    $showQuickExitButton ? `bottom: 58px;` : `bottom: 0;`}

  ${breakpoint.desktop`
    bottom: 0;
  `};

  z-index: 99;
  padding: 1em;
  background-color: ${({ theme }) => theme.palette.darkBackground};
`;

export const StyledLink = styled.a`
  ${buttonStyles};
  margin-right: 0.5em;
`;

export const StyledButton = styled(Button)`
  margin-left: ${({ $open }) => ($open ? `0.5em` : `0`)};
  min-height: 48px;
`;

export const SplitTestMsg = styled.div`
  color: ${({ theme }) => theme.palette.white};
  margin-right: 0.5em;
  p {
    margin-bottom: 0;
  }
`;
